import React, { useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { useInView } from "react-intersection-observer";
import { Link } from "react-router-dom";
import { motion, Variants } from "framer-motion";
import Scroll from '../../Layout/SmoothScroll';
import { useState } from "react";
function Article19() {
  const imageRef = useRef(null);

  const { ref: firstContainer, inView: firstInView } = useInView({
    threshold: 0
  });


  const getAnimationClass = () => {
    if (firstInView) {
      var img1 = document.getElementById("img1");
      img1.className = 'active';

      return "";
    }
  };

  const textAnimate = {
    offscreen: { y: 10, opacity: 0 },
    onscreen: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.25,
        duration: 0.5
      }
    }
  }
  const imgAnimate = {
    offscreen: { opacity: 0 },
    onscreen: {
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.25,
        delay: 0.5,
        duration: 0.5
      }
    }
  }

  const [addClass, setAddClass] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/article20');
      
    }, 1000); // Delay of 2000 milliseconds (2 seconds)
    
  };

  const handleClick1 = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/article18');
      
    }, 1000); // Delay of 2000 milliseconds (2 seconds)
    
  };

  const handleClick2 = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/');
      
    }, 1000); // Delay of 2000 milliseconds (2 seconds)
    
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 1 }}
    >
      <Scroll />
      <motion.div
        initial={"offscreen"}
        whileInView={"onscreen"}
        viewport={{ once: false, amount: 0.5 }}
        transition={{ staggerChildren: 0.25 }}
        className="magazine-wrap article-wrap"
      >
        <motion.div
          variants={imgAnimate}
          className="article-left"
        >
          {/* {getImage()} */}
          <img id="img1" className="active" src={require("../../Images/article19-left-img1.jpg")} />
        </motion.div>
        <div className="article-right scroll-sec">

          <motion.div variants={textAnimate} className="article-left-mob">
            <img src={require("../../Images/article19-left-img1.jpg")} alt="" />
          </motion.div>

          <motion.div
            variants={textAnimate}
            className="hamburger-menu mb-4 mb-sm-5">
            <Link to="/">
              <img
                src={require("../../Images/hamburger-menu-icon.png")}
              />
            </Link>
          </motion.div>
          <div className="article-mob-wrap">
          <div className="" ref={firstContainer}>
            <h1 className="fs-xl f-lora mb-1 text-purple">Bare Bones Chocolate</h1>
            <h2 className="mb-4 mb-sm-5 f-lora-i">Cacao goodness</h2>
            <h4 className="mb-4 mb-sm-5 f-lora-i lh-base">The Glasgow-based bean-to-bar chocolate producer Bare Bones Chocolate celebrates the purity of cacao beans in single-origin chocolate. As the awards fly in, founders Lara and Cam remain committed to the principles of flavour and fairness. </h4>

            <div className="row mb-4">
              <div className="col-sm-6">
                <p className="mb-3">Bare Bones Chocolate started with a phone call from a frazzled Lara Messer to her then boyfriend Cameron Dixon. The photographer was on the train home to Glasgow after a demanding fashion shoot when she found a craft chocolate bar in her bag. “I started eating it and daydreamed about how incredible it would be to make chocolate for a living,” she remembers. She immediately Googled how chocolate is made and phoned Cameron. “I couldn’t wait until I got home. I don’t think I’ve ever been so excited about something!” </p>
                <p className="mb-3">“Cam”, now Lara’s husband (they recently got married in the Bare Bones Chocolate workshop), was at the time a mechanical engineer in Glasgow, and was just as excited. The pair set to work, initially from home. It was 2017 and the craft chocolate market was tiny – “there was next to no information available about how to make it, so Cam’s engineering background was helpful,” says Lara. They spent a year sourcing and testing single-origin cacao beans and launched with the 70% Madagascar and 60% Honduras Milk in 2018. The milk chocolate won two stars at the Great Taste Awards within months of its launch. Now, almost every Bare Bones Chocolate product holds an award. </p>
                <p className="mb-3">Lara attributes this success to flavour. During the initial development process, she was “blown away” by how much every tiny tweak changed the flavour – and Lara and Cam have since dedicated themselves to tweaking to perfection. Their roasting process takes place on a modified coffee roaster for greater temperature control, and to spotlight the natural cacao, each bar contains only beans, raw unrefined cane sugar and a smidgen of cocoa butter. Ultimately, says Lara, the taste of single-origin cacao depends on the bean’s genetics, the fermentation process, and the terroir, climate and humidity it was grown in. </p>
              </div>
              <div className="col-sm-6">
                <p className="mb-3">This is why Lara describes their chocolate as “a passport through food that can have a positive impact on people and the planet”. They pay well above the fairtrade market rate and take a keen interest in the farmers they work with. They recently returned from a sourcing trip to Uganda, where they met cacao growers who were training to sell to the speciality market. “The speciality market is more complex than the mass market due to the process involved, but farmers can earn more money that can change their lives. We believe all chocolate should be farmed this way,” says Lara. </p>
                <p className="mb-3">Lara as a little girl “would have cried” if she knew she would one day run a chocolate brand. Her favourite product is the 70% Philippines dark, originally a limited edition: “It tastes like pecans and banoffee pie or even a tray of brownies. I think it is the best chocolate I’ve ever tasted – which sounds bold, but I’m positive you’ll agree with me.” Everyone did agree: it sold out immediately and has become a permanent stock fixture.  </p>
                <p className="mb-3">These days, Bare Bones Chocolate occupies a turquoisewindow-framed premises in the railway arches of Glasgow’s Osborne Street. It’s a bustling space, fresh and bright thanks to white-painted panels, and it’s here that the team of six manufactures chocolate, wraps it up in pretty pastel-coloured boxes made from recycled coffee cups, and carries out mail order, social media, wholesaling and customer service activities. There is a small factory shop too, where you can buy hot chocolate. Anyone for a single-origin Dominican Republic dark hot chocolate with vegan marshmallows?  </p>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-6">
                <img className="img-fluid mb-4"
                  src={require("../../Images/article19-right-img1.jpg")}
                />
              </div>
              <div className="col-sm-6">
                <img className="img-fluid mb-4"
                  src={require("../../Images/article19-right-img2.jpg")}
                />
              </div>
              <div className="col-sm-6">
                <img className="img-fluid mb-4"
                  src={require("../../Images/article19-right-img3.jpg")}
                />
              </div>
              <div className="col-sm-6">
                <img className="img-fluid mb-4"
                  src={require("../../Images/article19-right-img4.jpg")}
                />
              </div>
            </div>

          </div>

        </div>
        </div>
      </motion.div>
      
      <div className="btns-group">
        <button className="btn nxtPrv-btn" onClick={handleClick1}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" /></svg>
        </button>
        <button className="btn home-btn" onClick={handleClick2}> Contents </button>
        <button className="btn nxtPrv-btn" onClick={handleClick}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" /></svg>
        </button>
      </div>
      <button className={addClass ? 'active fold' : 'fold'} onClick={handleClick}></button>

      <div className={addClass ? 'active1 unfold' : 'unfold'}></div>

    </motion.div>

  );
}

export default Article19;
